define(['exports', 'react', '../../assets/info-icon.svg', 'react-tooltip'], function (exports, _react, _infoIcon, _reactTooltip) {
	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _react2 = _interopRequireDefault(_react);

	var _infoIcon2 = _interopRequireDefault(_infoIcon);

	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : {
			default: obj
		};
	}

	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}

	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);
			if (staticProps) defineProperties(Constructor, staticProps);
			return Constructor;
		};
	}();

	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}

		return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}

	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
		}

		subClass.prototype = Object.create(superClass && superClass.prototype, {
			constructor: {
				value: subClass,
				enumerable: false,
				writable: true,
				configurable: true
			}
		});
		if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}

	var ToolTipComponent = function (_Component) {
		_inherits(ToolTipComponent, _Component);

		function ToolTipComponent(props) {
			_classCallCheck(this, ToolTipComponent);

			var _this = _possibleConstructorReturn(this, (ToolTipComponent.__proto__ || Object.getPrototypeOf(ToolTipComponent)).call(this, props));

			_this.state = {};
			return _this;
		}

		_createClass(ToolTipComponent, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    className = _props.className,
				    style = _props.style,
				    label = _props.label,
				    message = _props.message,
				    toolTipId = _props.toolTipId;


				return _react2.default.createElement(
					'div',
					{ className: className, style: style },
					_react2.default.createElement(
						'div',
						{ ref: toolTipId + ' tooltip', 'data-effect': 'solid',
							className: 'semi-bold flex items-center', 'data-tip': true, 'data-for': toolTipId },
						_react2.default.createElement(
							'div',
							{ className: 'mr1 flex items-center' },
							_react2.default.createElement(_infoIcon2.default, null)
						),
						_react2.default.createElement(
							'div',
							null,
							label
						)
					),
					_react2.default.createElement(
						_reactTooltip2.default,
						{ style: { wordWrap: 'breakWord' }, className: 'col-2 react-ui-tooltip', id: toolTipId, multiline: true, effect: 'solid', place: 'bottom' },
						_react2.default.createElement(
							'p',
							null,
							message
						)
					)
				);
			}
		}]);

		return ToolTipComponent;
	}(_react.Component);

	exports.default = ToolTipComponent;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/common/ToolTipComponent.js
// module id = 179
// module chunks = 0